<template>
  <v-row dense no-gutters>
    <v-col cols="12">
      <components-table :project="project" :value="currentComponent" @input="onComponentUpdate" :decorateNumerals="true"/>
    </v-col>
    <v-col cols="12">
      <comp-properties-card :component="currentComponent" :active-tab="activeTab"/>
    </v-col>
    <prj-add-project-component-dialog :project="project" :comp="currentComponent" v-model="showAddComponentDialog" @componentAdded="onProjectComponentAdded" @componentUpdate="onProjectComponentUpdate"/>
    <sys-confirm-dialog :value="dlgShowConfirm" :message="'Подтвердите удаление'" :no-call-back="cancelConfirmDialog" :ok-call-back="doDeleteRcptComp"/>
  </v-row>
</template>

<script>
import ComponentsTable from '@/components/modules/projects/ui/tblComponentsTable'
import CompPropertiesCard from '@/components/modules/projects/cards/configuration/compPropertiesCard'
import { UI_ADD_ACTION, UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import PrjAddProjectComponentDialog from '@/components/modules/projects/dialogs/prjAddProjectComponentDialog'
import SysConfirmDialog from '@/components/common/dialogs/confirmDialog'
import axios from 'axios'

export default {
  name: 'projectComponentsCard',
  components: { SysConfirmDialog, PrjAddProjectComponentDialog, CompPropertiesCard, ComponentsTable },
  props: ['project', 'activeTab'],
  data () {
    return {
      currentComponent: [],
      dlgShowConfirm: false,
      showAddComponentDialog: false,
      addComponent: { text: 'Добавить компонент', actionType: 'Компоненты', action: 'addRcptComponent', method: this.addRcptComponent, icon: 'mdi-plus', params: '' },
      editComponent: { text: 'Изменить компонент', actionType: 'Компоненты', action: 'updRcptComponent', method: this.updRcptComponent, icon: 'mdi-pencil', params: '' },
      delComponent: { text: 'Удалить компонент', actionType: 'Компоненты', action: 'delRcptComponent', method: this.delRcptComponent, icon: 'mdi-close', params: '' }
    }
  },
  watch: {
    activeTab (val) {
      console.log('projectComponentsCard - tab changed to ', val)
      this.setActions()
    }
  },
  methods: {
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, {
        actionType: 'Компоненты',
        actions: []
      })
      if (this.activeTab === 'tabComponents') {
        this.$store.dispatch(UI_ADD_ACTION, this.addComponent)
        if (this.currentComponent.length > 0) {
          this.$store.dispatch(UI_ADD_ACTION, this.editComponent)
          this.$store.dispatch(UI_ADD_ACTION, this.delComponent)
        }
      }
    },
    addRcptComponent () {
      this.currentComponent = []
      this.showAddComponentDialog = true
    },
    updRcptComponent () {
      this.showAddComponentDialog = true
    },
    delRcptComponent () {
      this.dlgShowConfirm = true
    },
    cancelConfirmDialog () {
      this.dlgShowConfirm = false
    },
    onComponentUpdate (val) {
      this.currentComponent.splice(this.currentComponent, 1, ...val)
      this.setActions()
    },
    onProjectComponentAdded (data) {
      this.onComponentUpdate(data)
      this.showAddComponentDialog = false
    },
    onProjectComponentUpdate (data) {
      this.onComponentUpdate(data)
      this.showAddComponentDialog = false
    },
    doDeleteRcptComp () {
      console.log('Closing confirm dialog')
      this.dlgShowConfirm = false
      const self = this
      const processorPath = '/api/org/receptures/rcptDelReceptureComponent.php'
      const payload = { ...this.currentComponent[0] }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            self.currentComponent.splice(0, 1, { action: 'delete', COMP_ID: self.currentComponent[0].COMP_ID })
            this.$emit('onChange', {})
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    }
  },
  mounted () {
    this.setActions()
  },
  created () {
  }
}
</script>

<style scoped>

</style>
